import angular from 'angular';
import secureFileUploaderUploadStageComponent from './secureFileUploaderUploadStage.component';

let secureFileUploaderUploadStageModule = angular.module('secureFileUploaderUploadStage', []).component('secureFileUploaderUploadStage', secureFileUploaderUploadStageComponent);

export default secureFileUploaderUploadStageModule;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderUploadStage/secureFileUploaderUploadStage.js